import { createSlice } from "@reduxjs/toolkit";

export const customersSlice = createSlice({
  name: "customers",
  initialState: {
    uploads: [],
    themes: [],
    brands: [],
    countries: [],
    selectedPeriod: "30", // days
    chartType: "bar", // "bar" or "pie"
    customDateRange: null, // { start: Date | null, end: Date | null } for custom range
    selectedBrand: null, // null = all brands
    selectedSource: null, // null = all sources
    selectedCountry: null, // null = all countries
    selectedSubTheme: null, // null = all sub-themes (for ThemeDetail page)
    selectedSentiments: ["positive", "negative", "neutral"], // Array of selected sentiment types
    timeAggregation: "daily", // "daily", "weekly", or "monthly"
  },
  reducers: {
    setUploads: (state, action) => {
      state.uploads = action.payload;
    },
    setThemes: (state, action) => {
      state.themes = action.payload;
    },
    setBrands: (state, action) => {
      state.brands = action.payload;
    },
    setCountries: (state, action) => {
      state.countries = action.payload;
    },
    setSelectedPeriod: (state, action) => {
      state.selectedPeriod = action.payload;
      // Clear custom date range when preset period is selected
      if (action.payload !== "custom") {
        state.customDateRange = null;
      }
    },
    setChartType: (state, action) => {
      state.chartType = action.payload;
    },
    setCustomDateRange: (state, action) => {
      state.customDateRange = action.payload;
    },
    setSelectedBrand: (state, action) => {
      state.selectedBrand = action.payload;
    },
    setSelectedSource: (state, action) => {
      state.selectedSource = action.payload;
    },
    setSelectedCountry: (state, action) => {
      state.selectedCountry = action.payload;
    },
    setSelectedSubTheme: (state, action) => {
      state.selectedSubTheme = action.payload;
    },
    setTimeAggregation: (state, action) => {
      state.timeAggregation = action.payload;
    },
    toggleSentiment: (state, action) => {
      const sentiment = action.payload;
      const currentIndex = state.selectedSentiments.indexOf(sentiment);
      
      if (currentIndex > -1) {
        // Sentiment is selected, remove it
        state.selectedSentiments.splice(currentIndex, 1);
        // If array becomes empty, reset to all three (prevent empty state)
        if (state.selectedSentiments.length === 0) {
          state.selectedSentiments = ["positive", "negative", "neutral"];
        }
      } else {
        // Sentiment is not selected, add it
        state.selectedSentiments.push(sentiment);
      }
    },
  },
});

export const { setUploads, setThemes, setBrands, setCountries, setSelectedPeriod, setChartType, setCustomDateRange, setSelectedBrand, setSelectedSource, setSelectedCountry, setSelectedSubTheme, setTimeAggregation, toggleSentiment } = customersSlice.actions;

export default customersSlice.reducer;

